import DictionaryContainer from './DictionaryContainer';

export default DictionaryContainer;
